// Phase 1A Phase 9C.2 — Decision state icon definitions.
//
// 8 decision glyphs. Each describes user-action recommendations —
// never implies STRIKZA executes money movement. No thumbs-up,
// no star, no award.

import type { IconDef } from "./icon-types.ts";

export const DECISION_ICONS: Record<string, IconDef> = {
  "decision.confirm": {
    key: "decision.confirm",
    shapes: [{ type: "polyline", points: "5,13 10,18 19,7", strokeWidth: 2.2 }],
  },
  "decision.review": {
    key: "decision.review",
    shapes: [
      { type: "circle", cx: 11, cy: 11, r: 6 },
      { type: "line", x1: 15, y1: 15, x2: 19, y2: 19 },
    ],
  },
  "decision.reduce": {
    key: "decision.reduce",
    shapes: [
      { type: "line", x1: 12, y1: 5, x2: 12, y2: 19 },
      { type: "polyline", points: "7,14 12,19 17,14" },
    ],
  },
  "decision.remove": {
    key: "decision.remove",
    shapes: [
      { type: "line", x1: 6, y1: 6, x2: 18, y2: 18, strokeWidth: 2.2 },
      { type: "line", x1: 18, y1: 6, x2: 6, y2: 18, strokeWidth: 2.2 },
    ],
  },
  "decision.hold": {
    key: "decision.hold",
    shapes: [
      { type: "rect", x: 7, y: 6, width: 3.5, height: 12, rx: 0.6 },
      { type: "rect", x: 13.5, y: 6, width: 3.5, height: 12, rx: 0.6 },
    ],
  },
  "decision.partial_exit": {
    key: "decision.partial_exit",
    shapes: [
      { type: "line", x1: 4, y1: 12, x2: 16, y2: 12 },
      { type: "polyline", points: "13,9 16,12 13,15" },
      { type: "line", x1: 19, y1: 6, x2: 19, y2: 18 },
    ],
  },
  "decision.dismiss": {
    key: "decision.dismiss",
    shapes: [
      { type: "circle", cx: 12, cy: 12, r: 6 },
      { type: "line", x1: 8, y1: 16, x2: 16, y2: 8 },
    ],
  },
  "decision.manual_action": {
    key: "decision.manual_action",
    shapes: [
      {
        type: "path",
        d: "M9 14 V8 A1 1 0 0 1 11 8 V12 V7 A1 1 0 0 1 13 7 V12 V8 A1 1 0 0 1 15 8 V13",
      },
      {
        type: "path",
        d: "M15 13 V11 A1 1 0 0 1 17 11 V16 C17 18 15 20 12 20 C9 20 7 18 7 16 V12 A1 1 0 0 1 9 12 V14",
      },
    ],
  },
};
